import React, { useState } from 'react';
import ActorsImport from './actors/ActorsImport.js';
import { Box, Button, Typography } from '@mui/material';

const ActorsCSV = () => {
  const [importType, setImportType] = useState(null);

  const handleImportPlayers = () => {
    setImportType('players');
  };

  const handleImportTeams = () => {
    setImportType('teams');
  };

  return (
    <Box sx={{textAlign : 'center'}}>
      <Typography variant="h5">Import CSV Acteurs V2</Typography>
        <div>
          <Button onClick={handleImportPlayers}>Importer des joueurs</Button>
          <Button onClick={handleImportTeams}>Importer des équipes</Button>
        </div>
        {importType && <ActorsImport importType={importType} />}
    </Box>
  );
};

export default ActorsCSV;